import { createSelector } from '@reduxjs/toolkit';

import { projectClassIrisSelector } from 'src/selectors/projectClassIris';
import { projectLinkDataArraySelector } from 'src/selectors/projectLinkDataArray';
import { getClassHierarchy } from 'src/utils/getClassHierarchy';

export const projectClassHierarchySelector = (projectId: string) =>
  createSelector(
    projectLinkDataArraySelector(projectId),
    projectClassIrisSelector(projectId),
    getClassHierarchy
  );
